import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: resetUserBonuses } = actions;

export * from './actions';
export * from './thunks';
export * as userBonusesSelectors from './selectors';

export default reducer;
